import { render, staticRenderFns } from "./EventCardLectors.vue?vue&type=template&id=b9162748&scoped=true"
import script from "./EventCardLectors.vue?vue&type=script&lang=js"
export * from "./EventCardLectors.vue?vue&type=script&lang=js"
import style0 from "./EventCardLectors.vue?vue&type=style&index=0&id=b9162748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9162748",
  null
  
)

export default component.exports